module.exports = __webpack_public_path__ + "static/img/icon-modal.1da8f50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/withdraw/icon-modal.png
// module id = oPBE
// module chunks = 216